module.exports = __webpack_public_path__ + "static/media/services_diningout.9010ba85.jpg";